import { useAtom } from "jotai";
import { useEffect } from "react";
import { labelsAtom } from "../atoms";

const useLabelsHook = (allLabels) => {
  const [labels, setLabels] = useAtom(labelsAtom);

  const add = (data: any[]) => {
    const mapped = data.filter(
      (l) => !labels.find((label) => label.value === l.value)
    );
    setLabels([...labels, ...mapped]);
  };

  useEffect(() => {
    if (labels.length === 0) {
      setLabels(allLabels);
    }
  }, [allLabels, labels.length, setLabels]);

  return { labels, add };
};

export default useLabelsHook;
